module.exports = __webpack_public_path__ + "img/Sabah.665bb04b.png";